import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/routing/rootRoute.ts';
import { ProtectedRoute } from '@/features/dashboard/_root/components/ProtectedRoute.tsx';
import AppLayout from '@/features/dashboard/_root/components/AppLayout.tsx';
import { queryClient } from '@/App.tsx';
import { getMeQueryOptions } from '@/features/dashboard/_root/hooks/useMe.ts';
import { getCompanyTimezoneQueryOptions } from '@/features/dashboard/company/hooks/useGetCompanyTimezone.ts';
import { auth } from '@/lib/firebase.ts';
import AppLoader from '@/features/dashboard/_root/components/AppLoader.tsx';
import { setCompanyTimeZone } from '@/utils/timeUtils.ts';

export const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'app',
  beforeLoad: async () => {
    await auth.authStateReady();
    const user = auth.currentUser;
    const me = await queryClient.ensureQueryData(getMeQueryOptions(user));
    try {
      const { timeZone } = await queryClient.ensureQueryData(
        getCompanyTimezoneQueryOptions(),
      );
      setCompanyTimeZone(timeZone);
    } catch {
      // Bez strefy firmy momenty formatują się w strefie przeglądarki.
    }
    return me;
  },
  loader: ({ context }) => {
    return context;
  },
  component: () => (
    <ProtectedRoute>
      <AppLayout />
    </ProtectedRoute>
  ),
  pendingComponent: AppLoader,
});
